import View from '../../../../View'
import {connect} from '../../../../redux/utils'
import {getLicenseCounters, isAllowedToManageAccountSettings} from '../../common/selectors'
import Counter from './Counter'
import messageResource from "../../../../messageResource"
import {isLicenseUnlimited, isLicenseViolated, haveMoreLicenses} from '../../common/utils'

export class LicenseContainer extends View {
    constructor() {
        super()

        this.state = {
            canManageAccountsSettings: false,
            licenseCounters: {
                actualCount: 0,
                allowedCount: 0,
                extraUsersCount: 0,
                licenseViolated: false,
                remainingCount: 1,
            }
        }

        this.onStateChanged(() => {
            if (this._counterIsVisible()) {
                this.counter.show()

                this.counter.setState({
                    withWarning: this._isLicenseWithWarning(),
                    text: this._createLicenseCounterText()
                })
            } else {
                this.counter.hide()
            }
        })
    }

    afterRender() {
        this.counter = new Counter().init(this.$containerEl)
    }

    _counterIsVisible = () => {
        const {canManageAccountsSettings} = this.state
        return canManageAccountsSettings && !isLicenseUnlimited(this.state.licenseCounters)
    }

    _createLicenseCounterText = () => {
        const {extraUsersCount, remainingCount} = this.state.licenseCounters
        let text
        if (isLicenseViolated(this.state.licenseCounters)) {
            text = messageResource.getMessage(
                extraUsersCount === 1 ? "userlist.license.disable_user" : "userlist.license.disable_users",
                [extraUsersCount]
            )
        }
        else {
            const remainingCountText = haveMoreLicenses(this.state.licenseCounters)
                ? remainingCount
                : messageResource.getMessage("userlist.pagebody.no_licenses_left")

            text = messageResource.getMessage(
                remainingCount === 1 ? "userlist.pagebody.license_left" : "userlist.pagebody.licenses_left",
                [remainingCountText]
            )
        }

        return text
    }

    _isLicenseWithWarning = () => {
        return !isLicenseUnlimited(this.state.licenseCounters) && !haveMoreLicenses(this.state.licenseCounters)
    }
}

export default connect(
    state => ({
        canManageAccountsSettings: isAllowedToManageAccountSettings(state),
        licenseCounters: getLicenseCounters(state),
    })
)(LicenseContainer)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/license/LicenseContainer.js